

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.CcZFi3uA.js","_app/immutable/chunks/kCE9wz0g.js","_app/immutable/chunks/x-hq5fDG.js","_app/immutable/chunks/B1veta3r.js","_app/immutable/chunks/DAAR3e-c.js","_app/immutable/chunks/1NK_OeRJ.js"];
export const stylesheets = [];
export const fonts = [];
